import {
  UserIcon,
  BriefcaseIcon,
  AcademicCapIcon,
  BuildingOffice2Icon,
  ClockIcon,
  EyeIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/16/solid"
import { TargetType, ReportStatus } from "../../features/reports/api/reports.api"

export type ReportTypeMeta = {
  type: TargetType
  label: string
  singular: string
  description: string
  icon: React.ReactNode
  color: string
  ring: string
  gradient: string
}

export const REPORT_TYPES: ReportTypeMeta[] = [
  {
    type: "user",
    label: "Пользователи",
    singular: "User",
    description: "Жалобы на профили и поведение пользователей платформы",
    icon: <UserIcon className="w-5 h-5" />,
    color: "text-violet-600 bg-violet-50",
    ring: "ring-violet-200",
    gradient: "from-violet-500 to-purple-400",
  },
  {
    type: "job",
    label: "Вакансии",
    singular: "Vacancy",
    description: "Жалобы на размещённые вакансии и работодателей",
    icon: <BriefcaseIcon className="w-5 h-5" />,
    color: "text-blue-600 bg-blue-50",
    ring: "ring-blue-200",
    gradient: "from-blue-500 to-sky-400",
  },
  {
    type: "course",
    label: "Курсы",
    singular: "Course",
    description: "Жалобы на курсы и материалы менторов",
    icon: <AcademicCapIcon className="w-5 h-5" />,
    color: "text-emerald-600 bg-emerald-50",
    ring: "ring-emerald-200",
    gradient: "from-emerald-500 to-green-400",
  },
  {
    type: "china",
    label: "Компании Китая",
    singular: "Enterprise",
    description: "Жалобы на карточки китайских предприятий",
    icon: <BuildingOffice2Icon className="w-5 h-5" />,
    color: "text-red-600 bg-red-50",
    ring: "ring-red-200",
    gradient: "from-red-500 to-rose-400",
  },
]

export const REPORT_TYPE_MAP: Record<TargetType, ReportTypeMeta> = Object.fromEntries(
  REPORT_TYPES.map((t) => [t.type, t])
) as Record<TargetType, ReportTypeMeta>

export const isReportType = (v: string): v is TargetType =>
  REPORT_TYPES.some((t) => t.type === v)

export const STATUS_CONFIG: Record<ReportStatus, { label: string; className: string; icon: React.ReactNode }> = {
  pending:   { label: "Ожидает",    className: "bg-yellow-50 text-yellow-700 ring-1 ring-yellow-200",  icon: <ClockIcon className="w-3 h-3" /> },
  reviewed:  { label: "Рассмотрено", className: "bg-blue-50 text-blue-700 ring-1 ring-blue-200",         icon: <EyeIcon className="w-3 h-3" /> },
  resolved:  { label: "Решено",     className: "bg-green-50 text-green-700 ring-1 ring-green-200",      icon: <CheckCircleIcon className="w-3 h-3" /> },
  dismissed: { label: "Отклонено",  className: "bg-gray-100 text-gray-500 ring-1 ring-gray-200",        icon: <XCircleIcon className="w-3 h-3" /> },
}